import { createContext, useContext } from 'react';

import { DEFAULT_FINANCIAL_VALUE_DISPLAY, FinancialValueDisplayPreference } from '@/types/financialValueDisplay';

export interface FinancialValueDisplayContextValue {
    preference: FinancialValueDisplayPreference;
    source: 'account' | 'surface' | 'system' | 'workspace';
    surfacePreference?: FinancialValueDisplayPreference | null;
    setSurfacePreference?: (value: FinancialValueDisplayPreference | null) => void;
}

export const FinancialValueDisplayContext = createContext<FinancialValueDisplayContextValue>({
    preference: DEFAULT_FINANCIAL_VALUE_DISPLAY,
    source: 'system',
});

export const useFinancialValueDisplay = () => useContext(FinancialValueDisplayContext);
